import { useEffect } from "react";
import Overlay from "ol/Overlay";
import "../App.css";

const FeaturePopup = ({ map, selectInteraction, popupOverlayRef }) => {
  useEffect(() => {
    if (!map || !selectInteraction) return;

    // Create popup element and overlay
    const popupElement = document.createElement("div");
    popupElement.className = "feature-popup";

    const popupOverlay = new Overlay({
      element: popupElement,
      positioning: "bottom-center",
      stopEvent: false,
    });

    // Store popupOverlay in the provided ref
    if (popupOverlayRef) {
      popupOverlayRef.current = popupOverlay;
    }

    // Add overlay to map if not already present
    if (!map.getOverlays().getArray().includes(popupOverlay)) {
      map.addOverlay(popupOverlay);
    }

    // Event listener for selecting features
    const handleSelect = (event) => {
      const selectedFeature = event.selected[0];

      if (!selectedFeature) {
        // Hide the popup instead of removing the overlay
        if (popupOverlayRef.current) {
          popupOverlayRef.current.setPosition(undefined); // Hides the popup
        }
        return;
      }

      const properties = selectedFeature.getProperties();
      let pos = null;

      // Determine popup position based on feature geometry
      const geometry = selectedFeature.getGeometry();
      if (!geometry) return;
      const geometryType = geometry.getType();

      if (geometryType === "Point") {
        pos = geometry.getCoordinates();
      } else if (geometryType === "LineString") {
        const coords = geometry.getCoordinates();
        pos = coords[Math.floor(coords.length / 2)];
      } else if (geometryType === "Polygon") {
        pos = geometry.getInteriorPoint().getCoordinates();
      } else if (geometryType === "MultiPoint") {
        const coords = geometry.getCoordinates();
        pos = coords[0];
      } else if (geometryType === "MultiLineString") {
        const coords = geometry.getCoordinates();
        const firstLineString = coords[0];
        pos = firstLineString[Math.floor(firstLineString.length / 2)];
      } else if (geometryType === "MultiPolygon") {
        pos = geometry.getInteriorPoint().getCoordinates();
      }

      // Generate popup content
      let content = `<strong>Feature Information:</strong><br/>`;
      for (const [key, value] of Object.entries(properties)) {
        if (key !== "geometry") {
          const displayValue = value === null || value === undefined ? "" : value;
          content += `<strong>${key}:</strong> ${displayValue}<br/>`;
        }
      }

      // Set popup content and position
      popupElement.innerHTML = content;
      popupOverlay.setPosition(pos); // Show the popup at the feature position
    };

    // Attach the select event listener
    selectInteraction.on("select", handleSelect);

    // Cleanup
    return () => {
      if (selectInteraction && typeof selectInteraction.un === "function") {
        selectInteraction.un("select", handleSelect);
      }
      if (popupOverlayRef.current) {
        map.removeOverlay(popupOverlayRef.current); // Remove the overlay from the map
        popupOverlayRef.current = null; // Clear the reference
      }
    };
  }, [map, selectInteraction, popupOverlayRef]);

  return null; // Component does not render any visible React elements
};

export default FeaturePopup;
